import React, { useEffect, useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { API_URL, useAxios } from "../../../utils/const";
import { useToast } from "../../../Context/ToastContext";
import { Message } from "primereact/message";

const CreateModal = ({ toggleModal, getClassrooms }) => {

  const axiosInstance = useAxios();
  const { setToastObj } = useToast();

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getLocation();
  }, []);

  const closeModal = () => {
    toggleModal(false);
  };

  const getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setValue("latitude", position.coords.latitude);
          setValue("longitude", position.coords.longitude);
        },
        (error) => {
          setToastObj({
            msg: `${error.message}, izinkan akses lokasi di perangkat Anda`,
            type: "danger",
          });
        }
      );
    } else {
      setToastObj({
        msg: "Geolocation is not supported by your browser",
        type: "danger",
      });
    }
  };

  const handleSave = async (formData) => {
    setLoading(true);

    const data = {
      name: formData.name,
      latitude: formData.latitude.toString(),
      longitude: formData.longitude.toString(),
    };

    try {
      await axiosInstance.post(`${API_URL}/classrooms`, data);
      getClassrooms();
      setLoading(false);
      setToastObj({ msg: "Data Berhasil ditambahkan", type: "success" });
      closeModal();
    } catch (error) {
      let errorMessage = "Terjadi kesalahan";
      if (error.response.data.msg != undefined) {
        errorMessage = `Terjadi kesalahan, ${error.response.data.msg}`;
      } else {
        errorMessage = error.message;
      }
      setLoading(false);
      setToastObj({
        msg: errorMessage,
        type: "danger",
      });
      closeModal();
    }
  };

  return (
    <Modal show={toggleModal} onHide={closeModal}>
      <Modal.Header closeButton>
        <Modal.Title>
          <h6>Tambah Ruang Kelas</h6>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="form-group mb-3">
          <label className="form-label">Nama</label>
          <input
            {...register("name", {
              required: "Nama tidak boleh kosong!",
              minLength: {
                value: 2,
                message: "Nama minimal 2 karakter",
              },
              maxLength: {
                value: 60,
                message: "Nama maximal 60 karakter",
              },
            })}
            placeholder="Ex. Ruang 7B"
            type="text"
            className="form-control"
          />
          {errors.name && (
            <div className="">
              <Message
                className="mt-2 d-flex"
                severity="error"
                text={errors.name.message}
              />
            </div>
          )}
        </div>

        <div className="row mb-3">
          <div className="col-md-6">
            <div className="form-group">
              <label className="form-label">Latitude</label>
              <input
                {...register("latitude", {
                  required: "Latitude tidak boleh kosong!",
                  minLength: {
                    value: 2,
                    message: "Latitude minimal 2 karakter",
                  },
                  maxLength: {
                    value: 60,
                    message: "Latitude maximal 60 karakter",
                  },
                })}
                placeholder="Ex. -6.282435570012556"
                type="text"
                className="form-control"
              />
              {errors.latitude && (
                <div className="">
                  <Message
                    className="mt-2 d-flex"
                    severity="error"
                    text={errors.latitude.message}
                  />
                </div>
              )}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label className="form-label">Longitude</label>
              <input
                {...register("longitude", {
                  required: "Longitude tidak boleh kosong!",
                  minLength: {
                    value: 2,
                    message: "Longitude minimal 2 karakter",
                  },
                  maxLength: {
                    value: 60,
                    message: "Longitude maximal 60 karakter",
                  },
                })}
                placeholder="Ex. 106.7208836800115"
                type="text"
                className="form-control"
              />
              {errors.longitude && (
                <div className="">
                  <Message
                    className="mt-2 d-flex"
                    severity="error"
                    text={errors.longitude.message}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={closeModal}>
          Batal
        </Button>
        <Button
          variant="success"
          disabled={loading}
          onClick={handleSubmit(handleSave)}
        >
          {loading && (
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
            />
          )}
          <span className="ml-1">Simpan</span>
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CreateModal;
